import type React from 'react';

import { useTreatAddressPlaceholderExperiment } from '#src/app/pages/petitionDetails/shared/hooks';

/**
 * Arm-independent tracking for the sign form address placeholder experiment: treats it and fires
 * `$exposure` once the visitor reaches the address step.
 *
 * Renders nothing. Must be mounted exactly once, from a location that renders in every arm — it must NOT
 * go inside the sign form, since the desktop sidebar, the mobile embedded form and the mobile sign modal
 * each mount their own and exposure dedup is per mount.
 */
export const AddressPlaceholderTracking: React.FC = () => {
	useTreatAddressPlaceholderExperiment();

	return null;
};
